import { render, staticRenderFns } from "./formSubmit_mobile.vue?vue&type=template&id=e55b263c&scoped=true&"
import script from "./formSubmit_mobile.vue?vue&type=script&lang=js&"
export * from "./formSubmit_mobile.vue?vue&type=script&lang=js&"
import style0 from "./formSubmit_mobile.vue?vue&type=style&index=0&id=e55b263c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55b263c",
  null
  
)

export default component.exports